import { createSlice } from '@reduxjs/toolkit';
import { AppDispatch } from '../..';
import { IProduct, IAppSliceConfig } from '../../../types';
import CONFIG from '../../../config';
import axios from 'axios';
import {
  formatMasterProductPrice,
  formatVariantProductPrice,
  getProductImage
} from '../../../utils';

interface IProductsSlice {
  isFetching: boolean;
  data: IProduct[];
  error: boolean;
}

const products = createSlice({
  name: 'products',
  initialState: {
    isFetching: false,
    data: [],
    error: false
  } as IProductsSlice,
  reducers: {
    fetchStarted(state) {
      state.isFetching = true;
    },
    setProducts(state, action) {
      state.data = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isFetching = false;
      state.data = [];
    }
  }
});

export const { fetchStarted, setProducts, setError } = products.actions;

export default products.reducer;

export const fetchProducts = (
  appSettings: IAppSliceConfig,
  productIds: string[]
) => async (dispatch: AppDispatch) => {
  try {
    dispatch(fetchStarted());
    const endpoint = `https://${CONFIG.apiHost}/s/${
      appSettings.siteId
    }/dw/shop/v20_4/products/(${productIds.join(
      ','
    )})?expand=prices,images,variations,promotions&currency=${appSettings.currency.toUpperCase()}&client_id=${
      process.env.REACT_APP_OCAPI_CLIENTID
    }`;

    const response = await axios(endpoint);
    if (response.status !== 200) {
      throw new Error();
    }

    const products: IProduct[] = response.data.data.map((product: any) => {
      /**
       * If Product does not have the c_cisplay_price property,
       * it should be treated as a variant product.
       */
      const displayPrice = product.c_display_price
        ? formatMasterProductPrice(product.price, product.c_display_price)
        : formatVariantProductPrice(product);

      const data: IProduct = {
        id: product.id,
        name: product.name,
        price: product.price,
        displayPrice,
        images: {
          boxShot: getProductImage(product.image_groups)
        },
        _originalData: product
      };

      return data;
    });

    dispatch(setProducts(products));
  } catch (e) {
    dispatch(setError(true));
  }
};
